export enum PNLAndWhatIfSize {
  SMALL = "small",
  MEDIUM = "medium",
  LARGE = "large",
}

export type PnlEWRow = {
  win: string;
  winRaw: number;
  placed: string;
  placedRaw: number;
  unplaced: string;
  unplacedRaw: number;
  hasMarker?: boolean;
};

export type PNLAndWhatIfProps = {
  size?: PNLAndWhatIfSize;
  previousPnl?: string;
  pnl?: string;
  rawPnl?: number;
  whatIf?: string;
  rawWhatIf?: number;
  disabled?: boolean;
  agnostic?: boolean;
  boosted?: boolean;
  pnlAndWhatIfEachWay?: PnlEWRow[];
};
